import { ImportedRanking } from './ImportedRanking';

/**
 * Class representing a container imported ranking.
 * @extends ImportedRanking
 */
export class ContainerImportedRanking extends ImportedRanking {}
